import { useEffect, useState } from "react";

const navItems = [
  { label: '吃瓜现场', href: '#live' },
  { label: '今日热榜', href: '#toplist' },
  { label: '现场直击', href: '#spotlight' },
  { label: '常见问题', href: '#faq' },
];

export default function Navbar() {
  const [scrolled, setScrolled] = useState(false);
  const [open, setOpen] = useState(false);

  useEffect(() => {
    const onScroll = () => setScrolled(window.scrollY > 16);
    window.addEventListener('scroll', onScroll);
    return () => window.removeEventListener('scroll', onScroll);
  }, []);

  return (
    <header
      className={`fixed inset-x-0 top-0 z-50 transition-all duration-300 ${
        scrolled || open ? 'bg-background-50/95 shadow-sm border-b border-background-200' : 'bg-transparent border-b border-transparent'
      }`}
    >
      <div className="mx-auto flex max-w-7xl items-center justify-between px-4 md:px-6 py-3">
        {/* brand */}
        <a href="#top" className="flex items-center gap-2">
          <span className="flex h-9 w-9 items-center justify-center rounded-lg bg-primary-500 text-background-50">
            <i className="ri-fire-fill text-lg"></i>
          </span>
          <span className="font-display text-xl font-bold tracking-tight text-foreground-950">cg51</span>
          <span className="hidden sm:block rounded-full bg-primary-100 px-2 py-0.5 text-[11px] font-medium text-primary-700">吃瓜现场</span>
        </a>

        {/* desktop nav */}
        <nav className="hidden items-center gap-1 md:flex">
          {navItems.map((item) => (
            <a key={item.label} href={item.href} className="rounded-md px-3 py-2 text-sm font-medium text-foreground-700 hover:text-primary-600 hover:bg-primary-50 whitespace-nowrap">
              {item.label}
            </a>
          ))}
        </nav>

        <div className="hidden items-center gap-2 md:flex">
          <a href="#live" className="rounded-md px-3 py-2 text-sm font-medium text-foreground-700 hover:bg-secondary-100 whitespace-nowrap">
            我吃过
          </a>
          <a href="#spotlight" className="flex items-center gap-1.5 whitespace-nowrap rounded-md bg-primary-500 px-4 py-2 text-sm font-medium text-background-50 hover:bg-primary-600 transition-colors">
            <i className="ri-vip-crown-line"></i>
            前排围观
          </a>
        </div>

        {/* mobile toggle */}
        <button
          type="button"
          aria-label="菜单"
          className="flex h-9 w-9 items-center justify-center rounded-md text-foreground-900 md:hidden hover:bg-secondary-100"
          onClick={() => setOpen((v) => !v)}
        >
          <i className={`${open ? 'ri-close-line' : 'ri-menu-line'} text-xl`}></i>
        </button>
      </div>

      {/* mobile panel */}
      {open && (
        <div className="border-t border-background-200 bg-background-50 md:hidden px-4 pb-4 pt-2">
          <nav className="flex flex-col gap-1">
            {navItems.map((item) => (
              <a key={item.label} href={item.href} onClick={() => setOpen(false)} className="rounded-md px-3 py-2.5 text-sm font-medium text-foreground-800 hover:bg-primary-50 hover:text-primary-700">
                {item.label}
              </a>
            ))}
            <a href="#spotlight" onClick={() => setOpen(false)} className="mt-1 flex items-center justify-center gap-1.5 whitespace-nowrap rounded-md bg-primary-500 px-4 py-2.5 text-sm font-medium text-background-50">
              <i className="ri-vip-crown-line"></i>
              前排围观吃瓜现场
            </a>
          </nav>
        </div>
      )}
    </header>
  );
}